require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./the-sheriff-in-these-parts.json") })
        }
      }, "path---the-sheriff-in-these-parts");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---the-sheriff-in-these-parts!./.cache/json/the-sheriff-in-these-parts.json
// module id = 572
// module chunks = 231608221292675